import React, { useEffect, useState } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import "../../css/Admin-Education/AdminEducationCard.css";
import AdminEditEducation from "./AdminEditEducation";
import { toast } from "react-toastify";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const AdminEducationCard = ({ data, fetchData,projectKey }) => {
  const [editProject, setEditProject] = useState(false);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this Education?")) {
      try {
        await deleteDoc(doc(db, "educations", projectKey));
        toast.success("Education deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete Education");
      }
    }
  };


  return (
    <div className="product-container">
      <div className="product-card">
        <div className="product-image-div">
          <img
            src={data.educationCertificates}
            alt={data.educationCertificates}
            className="product-image"
          />
        </div>
        <h1 className="product-name">{data.educationInstitute}</h1>
        <p className="product-description">{data.educationName}</p>
        <div className="product-buttons">
          

          <div className="edit-button" onClick={() => setEditProject(true)}>
            <MdModeEditOutline style={{fontSize:'1.5rem' }}/>
          </div>

          <div className="delete-button" onClick={handleDelete}>
            <MdDelete style={{ fontSize: "1.5rem" ,color:"white"}} />
          </div>

        </div>
      </div>

      {editProject && (
                <AdminEditEducation onClose={() => setEditProject(false)} productData={data} fetchData={fetchData} projectKey={projectKey}/>
            )}
    </div>
  );
};

export default AdminEducationCard;
